<div adaptToolbarContent>
    @if (canEditProduct) {
        <button adaptButton="add"
                [disabled]="hasChanges"
                [adaptBlockingClick]="createProduct"
                data-test="add-progress-product">module</button>
        <button adaptButton="import"
                [disabled]="hasChanges"
                [adaptBlockingClick]="importProducts"
                data-test="import-progress-products">journey progress</button>
    }
</div>
@if (canEditProduct) {
    <div adaptToolbarContent
         alignment="right"
         [ordinal]="0">
        <button adaptButton="editLink"
                [(adaptButtonToggle)]="isEditing"
                data-test="edit-journey-progress">Edit</button>
    </div>
}
@if (hasCategories) {
    <div adaptToolbarContent
         alignment="right"
         [ordinal]="1">
        <button [adaptButton]="categoryDisplayMode === CategoryDisplayMode.All ? 'expandLink' : 'collapseLink'"
                (click)="cycleCategoryDisplay()"
                data-test="cycle-progress-categories">{{ categoryDisplayMode }}</button>
    </div>
}
@if (errorMessage) {
    <p class="alert alert-danger">{{ errorMessage }}</p>
}
@if (progressProducts.length === 0) {
    <p class="text-muted">No journey progress modules have been defined yet.</p>
}
<div class="d-flex flex-column gap-4">
    <adapt-styled-dashboard-element name="Progress"
                                    class="progress-container"
                                    [isCollapsible]="true"
                                    [background]="false">
        <div class="d-flex flex-wrap gap-3">
            @if (categoryChartData[0]; as categoryData) {
                <div class="total-progress-container flex-grow-1">
                    <ng-container *ngTemplateOutlet="pieChart; context: { $implicit: categoryData }"></ng-container>
                </div>
            }

            @if (categoryChartData.length > 1) {
                <div class="total-progress-container flex-grow-1 d-flex flex-wrap gap-3 justify-content-evenly">
                    @for (categoryData of categoryChartData; track categoryData.name; let first = $first) {
                        @if (!first) {
                            <ng-container *ngTemplateOutlet="pieChart; context: { $implicit: categoryData }"></ng-container>
                        }
                    }
                </div>
            }
        </div>
    </adapt-styled-dashboard-element>

    <dx-sortable class="d-flex flex-column gap-4"
                 data-test="journey-progress-products"
                 handle=".journey-product-drag-handle"
                 [data]="progressProducts"
                 [moveItemOnDrop]="true"
                 [allowReordering]="canEditProduct && isEditing && !hasChanges"
                 (onReorder)="onProductReorder($event)">
        @for (product of progressProducts; track product.progressProductId) {
            <adapt-styled-dashboard-element [name]="product.name"
                                            [attr.data-progress-product-id]="product.progressProductId"
                                            class="progress-product"
                                            [iconClass]="canEditProduct && isEditing ? 'fas fa-grip-dots-vertical journey-product-drag-handle' : undefined">
                @if (showCodes) {
                    <span adapt-collapsible-header-title>(code <code>{{ product.code ?? "N/A" }}</code>)</span>
                }
                @if (canEditProduct && isEditing) {
                    <div adapt-collapsible-header-action-right>
                        <button class="btn-toolbar btn-pill"
                                adaptButton="add"
                                [disabled]="hasChanges"
                                data-test="add-progress-category"
                                [adaptBlockingClick]="createCategory"
                                [adaptBlockingClickParam]="product">category</button>
                        <button class="btn-toolbar btn-pill"
                                adaptButton="edit"
                                [disabled]="hasChanges"
                                data-test="edit-progress-product"
                                [adaptBlockingClick]="editProduct"
                                [adaptBlockingClickParam]="product">journey progress module</button>
                        <button class="btn-toolbar btn-pill"
                                adaptButton="delete"
                                [disabled]="hasChanges"
                                data-test="delete-progress-product"
                                [adaptBlockingClick]="deleteProduct"
                                [adaptBlockingClickParam]="product"
                                [unsubscribeOnDestroy]="false">journey progress module</button>
                    </div>
                }
                <dx-sortable class="d-flex flex-column gap-4"
                             data-test="journey-progress-categories"
                             handle=".progress-category-drag-handle"
                             [data]="product.progressCategories"
                             [moveItemOnDrop]="true"
                             [allowReordering]="canEditProduct && isEditing && !hasChanges"
                             (onReorder)="onCategoryReorder($event, product)">
                    @for (category of product.progressCategories; track category.progressCategoryId) {
                        @if (category && !category.entityAspect.entityState.isDetached()) {
                            <adapt-edit-progress-category [category]="category"
                                                          [attr.data-progress-category-id]="category.progressCategoryId"
                                                          [canEdit]="canEdit"
                                                          [canEditProduct]="canEditProduct && isEditing"
                                                          (categoryEdit)="editCategory(category).subscribe()"
                                                          (categoryDelete)="deleteCategory(category).subscribe()"></adapt-edit-progress-category>
                        }
                    } @empty {
                        <p class="text-muted mb-0">No categories have been defined yet.</p>
                    }
                </dx-sortable>
            </adapt-styled-dashboard-element>
        }
    </dx-sortable>
</div>

<ng-template #pieChart
             let-categoryData>
    <adapt-styled-dashboard-element [name]="categoryData.name"
                                    [nested]="true">
        <dx-pie-chart [dataSource]="categoryData.data"
                      [customizePoint]="customiseChartPoint"
                      [startAngle]="90"
                      resolveLabelOverlapping="shift"
                      sizeGroup="pieGroup"
                      class="d-flex justify-content-center"
                      (onDone)="updateChartDimensionAndSubscribeSizeChange($event)">
            <dxo-pie-chart-animation [enabled]="false"></dxo-pie-chart-animation>
            <dxo-pie-chart-legend orientation="horizontal"
                                  itemTextPosition="right"
                                  horizontalAlignment="center"
                                  verticalAlignment="bottom"
                                  [columnCount]="4"></dxo-pie-chart-legend>
            <dxi-pie-chart-series argumentField="label"
                                  [minSegmentSize]="0"
                                  valueField="percent">
                <dxo-pie-chart-label [visible]="true"
                                     position="inside"
                                     [customizeText]="customizeLabel">
                    <dxo-pie-chart-font [size]="11"></dxo-pie-chart-font>
                    <dxo-pie-chart-connector [visible]="true"
                                             [width]="0.5"></dxo-pie-chart-connector>
                </dxo-pie-chart-label>
            </dxi-pie-chart-series>
            <dxo-pie-chart-size [height]="200"
                                [width]="250"></dxo-pie-chart-size>
            <dxo-pie-chart-tooltip [enabled]="true"
                                   [customizeTooltip]="customiseChartTooltip"></dxo-pie-chart-tooltip>
        </dx-pie-chart>
    </adapt-styled-dashboard-element>
</ng-template>
